/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { ServiceApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const serviceApi = {
  get: wrap(ServiceApi, ServiceApi.prototype.getServiceById),
  getCalendarServiceById: wrap(
    ServiceApi,
    ServiceApi.prototype.getCalendarServiceById,
  ),
  holdDates: wrap(ServiceApi, ServiceApi.prototype.indexServiceHoldDate),
  getServiceById: wrap(ServiceApi, ServiceApi.prototype.getServiceById),
  getServiceMenuById: wrap(ServiceApi, ServiceApi.prototype.getServiceMenuById),
  getSpecialCommercialLaw: wrap(
    ServiceApi,
    ServiceApi.prototype.getSpecialCommercialLawById,
  ),
  getPrivacyPolicy: wrap(
    ServiceApi,
    ServiceApi.prototype.getPrivacyPolicyByServiceId,
  ),
  getServiceComponents: wrap(
    ServiceApi,
    ServiceApi.prototype.getServiceComponents,
  ),
  getServiceComponentsByIds: wrap(
    ServiceApi,
    ServiceApi.prototype.getServiceComponentsByIds,
  ),
};

export default serviceApi;
